import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useCookie } from 'react-use';

import { getTeamIdFromPath } from 'utils/path';

export const SetTeamIdCookie = () => {
    const location = useLocation();
    const [teamId, setTeamId] = useState<number | null>(null);

    useEffect(() => setTeamId(getTeamIdFromPath()), [location]);

    const [, update] = useCookie('lab_team_id');
    useEffect(() => {
        if (teamId) {
            update(String(teamId));
        }
    }, [teamId, update]);

    return null;
};
